// EN translations
export const en = {
    // Navigation
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      successStories: 'Success Stories',
      blog: 'Blog',
      contact: 'Contact'
    },
    // Hero Section
    hero: {
      badge: 'Expert Genealogist Laura Stella - 30 Years Experience',
      title: 'Discover Your',
      titleHighlight: 'Italian Heritage',
      description: 'Professional genealogy research connecting you to your Italian roots',
      introHeadline: 'Every family story begins with a question. We help you find the answers.',
      introSupport: 'Research based on real historical sources, verifiable documents, and dedicated human support.',
      cta: 'Start Your Journey',
      viewServices: 'View Services',
      stats: {
        projects: 'Projects Completed',
        experience: 'Years Experience',
        countries: 'Countries Served'
      },
      certified: 'Certified Expert',
      certifiedSub: 'Italian Archives Research'
    },
    // Services Section
    services: {
      title: 'Our Services',
      subtitle: 'Complete solutions for genealogical research',
      items: [
        {
          title: 'Genealogical Research',
          description: 'In-depth research of Italian archives to trace your family history through generations.'
        },
        {
          title: 'Document Retrieval',
          description: 'We obtain birth, marriage and death certificates from Italian municipal and parish archives.'
        },
        {
          title: 'Citizenship Assistance',
          description: 'Expert guidance through the Italian citizenship application process by descent (jure sanguinis).'
        },
        {
          title: 'Document Translation',
          description: 'Professional translation and apostille of Italian documents for legal use.'
        },
        {
          title: 'Ancestral Tours',
          description: 'Customized trips to your family\'s places of origin in Italy.'
        }
      ]
    },
    // About Section
    about: {
      title: 'About Us',
      subtitle: 'Your Partner in Italian Heritage Discovery',
      description1: 'With over 30 years of experience in Italian genealogical research, Laura Stella has helped hundreds of families discover their Italian roots and obtain Italian citizenship.',
      description2: 'Our team of expert researchers works directly with Italian archives, parishes and municipal offices to find the documents necessary for your family research.',
      features: [
        'Direct access to Italian archives',
        'Native speaker research team',
        'Over 500 success cases',
        'Complete citizenship support'
      ]
    },
    // Success Stories
    stories: {
      title: 'Success Stories',
      subtitle: 'Families who discovered their roots',
      items: [
        {
          name: 'Marco R.',
          location: 'New York, USA',
          quote: 'The precision and accuracy of the research amazed me. They found details about my family that even my grandparents didn\'t know!'
        },
        {
          name: 'Sarah M.',
          location: 'Sydney, Australia',
          quote: 'They found documents from my family dating back to the 1800s. An incredible experience.'
        },
        {
          name: 'Carlos G.',
          location: 'Buenos Aires, Argentina',
          quote: 'Professionalism and dedication. They solved a complex case that others had abandoned.'
        }
      ]
    },
    // Blog
    blog: {
      title: 'Genealogy Blog',
      subtitle: 'Guides, tips and stories about Italian genealogical research',
      readMore: 'Read Article',
      backToSite: 'Back to Site',
      backToBlog: 'Back to Blog',
      minRead: 'min read',
      categories: {
        citizenship: 'Citizenship',
        research: 'Research',
        genealogy: 'Genealogy',
        documents: 'Documents'
      }
    },
    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'Start your journey to Italian roots',
      form: {
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        ancestorOrigin: 'Your ancestor\'s place of origin (if known)',
        submit: 'Send Request'
      },
      info: {
        title: 'Contact Information',
        email: 'italianrootsdiscovery@gmail.com',
        phone: '+39 3318792031',
        address: 'Milan • Turin • Genoa • Venice • Padua • Rome • Naples • Palermo'
      }
    },
    // Footer
    footer: {
      description: 'Professional genealogy research connecting you to your Italian roots.',
      quickLinks: 'Quick Links',
      contactUs: 'Contact Us',
      followUs: 'Follow Us',
      rights: 'All rights reserved.',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy',
      cookies: 'Cookie Policy'
    }
  };
